<template>
    <div class="w-full h-11 px-3.5 py-2.5 bg-primary-600 justify-center items-center flex">
        <p class="leading-6 font-normal text-white text-center py-3">
            <span class="font-medium">This is a live demo</span> If you want these stats for your team or company,
            <a href="https://calendly.com/d/z86-3md-pbv/1-1-email-meter-demo" target="_blank" class="underline">get in touch</a>
        </p>
    </div>
</template>
